<patron-modal
  [visible]="visible"
  (cancel)="close()"
  size="xl"
  title="Apontamentos"
  [showFooter]="false"
  class="header-fix"
  id="ticketlogs">
  <patron-card
    [header]="currentTicketLog ? 'Apontamento atual' : 'Novo apontamento'"
    [contentTemplate]="formContent"
    styleClass="mb-3 rounded-0">
    <ng-template #formContent>
      <patron-form [formGroup]="logForm" (onSubmit)="save()">
        <div class="row">
          <div class="col-6 py-0">
            <div class="form-group row">
              <patron-form-field
                type="datetime-local"
                formControlName="startDate"
                [formGroup]="logForm"
                label="Horário Início">
              </patron-form-field>
            </div>
          </div>
          <div class="col-6 py-0">
            <div class="form-group row">
              <patron-form-field
                type="datetime-local"
                formControlName="endDate"
                [formGroup]="logForm"
                label="Horário Final">
              </patron-form-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6 py-0">
            <div class="form-group row">
              <label class="col-12 py-0 col-form-label font-weight-bold ml-1" for="attendanceType"
                >Atendimento</label
              >
              <div class="col-12 py-0 mt-3">
                <div class="row justify-content-around">
                  @for (type of ticketLogAttendanceTypes; track type) {
                    <div class="col-auto py-0">
                      <patron-radio
                        formControlName="attendanceType"
                        name="attendanceType"
                        [value]="type.value"
                        [label]="type.label"></patron-radio>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 py-0">
            <div class="form-group row">
              <patron-select
                [formGroup]="logForm"
                formControlName="type"
                [items]="ticketLogTypes"
                bindLabel="label"
                label="Tipo"
                placeholder="Tipo">
              </patron-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6 py-0">
            <div class="form-group row">
              <patron-select
                [formGroup]="logForm"
                formControlName="departmentType"
                [items]="ticketLogDepartmentTypes"
                bindLabel="label"
                label="Setor"
                placeholder="Setor">
              </patron-select>
            </div>
          </div>
          <div class="col-6 py-0">
            <div class="form-group row">
              <patron-select
                [formGroup]="logForm"
                formControlName="status"
                placeholder="Status"
                bindLabel="description"
                orderBy="description"
                label="Status"
                modelName="ticket-statuses">
              </patron-select>
            </div>
          </div>
        </div>

        @if (entity && entity.tasks?.length) {
          <div class="form-group row mb-3">
            <label class="col-12 py-0 col-form-label font-weight-bold" for="task-radios"
              >Tarefa</label
            >
            <div class="col-12 py-0 mt-3">
              <div class="row">
                @for (task of entity.tasks | sort: ['created_at', 'sequence']; track task) {
                  <div class="col-auto py-0">
                    <patron-radio
                      formControlName="task"
                      name="task"
                      [value]="task.id"
                      [label]="task.sequence + ' - ' + task.summary"
                      [disabled]="taskRadioDisabled"></patron-radio>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <div class="mb-3">
          <app-system-percentages
            [inputSystem]="inputSystem"
            [currentTicketLog]="currentTicketLog"
            [entity]="entity"
            [loading]="loading || searchingCurrentTicketLog || saving"></app-system-percentages>
        </div>

        <div class="row">
          <div class="col py-0">
            <patron-textarea
              [formGroup]="logForm"
              formControlName="description"
              label="Descrição"
              rows="2"
              [includeBR]="false">
            </patron-textarea>
          </div>
        </div>

        <div class="row mt-2 align-items-center">
          <div class="col-auto py-0 pl-2">
            <patron-form-check [inputTemplate]="inputIsPublic" [labelTemplate]="labelIsPublic">
              <ng-template #inputIsPublic>
                <input type="checkbox" id="isPublic" formControlName="isPublic" />
              </ng-template>
              <ng-template #labelIsPublic>
                <label for="labelIsPublic">Público</label>
              </ng-template>
            </patron-form-check>
          </div>

          <div class="col-auto py-0">
            <patron-form-check [inputTemplate]="inputSADTTD" [labelTemplate]="labelSADTTD">
              <ng-template #inputSADTTD>
                <input
                  type="checkbox"
                  id="shouldAddDescriptionToTicketDetails"
                  formControlName="shouldAddDescriptionToTicketDetails" />
              </ng-template>
              <ng-template #labelSADTTD>
                <label for="shouldAddDescriptionToTicketDetails"
                  >Adicionar descrição nos comentários</label
                >
              </ng-template>
            </patron-form-check>
          </div>

          <div class="col py-0">
            <div class="row justify-content-end">
              <div class="col-auto py-0">
                <patron-button
                  type="submit"
                  [loading]="loading || searchingCurrentTicketLog || saving"
                  size="lg">
                  {{ mainButtonLabel | truncate: [40] }}
                </patron-button>
              </div>
            </div>
          </div>
        </div>
      </patron-form>
    </ng-template>
  </patron-card>

  <patron-card header="Apontamentos" [contentTemplate]="listContent" styleClass="rounded-0">
    <ng-template #listContent>
      @if (loading) {
        <div class="row">
          <div class="col py-0 text-muted text-center mt-2">
            <i class="fa fa-spin fa-spinner fa-3x"></i><br />
            <b><i>Carregando apontamentos...</i></b>
          </div>
        </div>
      }

      @if (!loading && !ticketLogs.length) {
        <div class="row">
          <div class="col py-0 text-muted text-center mt-2">
            <b><i>Nenhum apontamento encontrado</i></b>
          </div>
        </div>
      }

      @if (!loading && ticketLogs.length) {
        <div>
          @for (ticketLog of ticketLogs; track ticketLog; let i = $index) {
            <div class="row py-1" [ngClass]="{ 'surface-ground': i % 2 != 0 }">
              <div class="col-3 py-0">
                <div class="row">
                  <div class="col-12 py-0">
                    <b>Usuário: </b><span>{{ ticketLog.user?.name }}</span>
                  </div>
                  @if (ticketLog.task) {
                    <div class="col-12 py-0">
                      <b>Tarefa: </b>
                      @if (ticketLog.task) {
                        <span>{{ ticketLog.task.sequence }} - {{ ticketLog.task.summary }}</span>
                      }
                    </div>
                  }
                  <div class="col-12 py-0">
                    <b>Sistema: </b><span>{{ ticketLog.system?.description }}</span>
                  </div>
                </div>
              </div>
              <div class="col-3 py-0">
                <div class="row">
                  <div class="col-12 py-0">
                    <b>Início: </b><span>{{ ticketLog.start_date | timeToDate }}</span>
                  </div>
                  <div class="col-12 py-0">
                    <b>Final: </b><span>{{ ticketLog.end_date | timeToDate }}</span>
                  </div>
                  <div class="col-12 py-0">
                    <b>Tempo: </b
                    ><span>{{ ticketLog.start_date | ticketLogTime: ticketLog.end_date }}</span>
                  </div>
                </div>
              </div>
              <div class="col-3 py-0">
                <div class="row">
                  <div class="col-12 py-0">
                    <b>Situação: </b
                    ><span>{{ ticketLog.situation ? 'Finalizado' : 'Em execução' }}</span>
                  </div>
                  <div class="col-12 py-0">
                    <b>Status: </b><span>{{ ticketLog.status?.description }}</span>
                  </div>
                </div>
              </div>
              <div class="col-3 py-0">
                <div class="row">
                  <div class="col-12 py-0">
                    <b>Atendimento: </b
                    ><span>{{ ticketLog.attendance_type | ticketLogAttendanceType }}</span>
                  </div>
                  <div class="col-12 py-0">
                    <b>Tipo: </b><span>{{ ticketLog.type | ticketLogType }}</span>
                  </div>
                  <div class="col-12 py-0">
                    <b>Setor: </b
                    ><span>{{ ticketLog.department_type | ticketLogDepartmentType }}</span>
                  </div>
                </div>
              </div>
              @if (ticketLog.description && ticketLog.description.length) {
                <div class="col-12 markdown-description">
                  <b>Descrição: </b>
                  <markdown [data]="ticketLog.description"></markdown>
                </div>
              }
            </div>
          }
        </div>
      }

      <patron-paginator
        [totalRecords]="totalItems"
        [findOptions]="findOptions"
        (onPageChange)="paginate($event)"
        #paginator>
      </patron-paginator>
    </ng-template>
  </patron-card>
</patron-modal>
